import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import sharcLogo from './sharc_nav_logo.png';
import ArtistList from './pages/ArtistList';
import ArtistDetail from './pages/ArtistDetail';
import VenueList from './pages/VenueList';
import VenueDetail from './pages/VenueDetail';
import AddArtist from './pages/AddArtist';
import AddVenue from './pages/AddVenue';
import AddEvent from './pages/AddEvent';
import EventList from './pages/EventList';
import EventDetail from './pages/EventDetail';
import EditArtist from './pages/EditArtist';
import EditVenue from './pages/EditVenue';
import EditEvent from './pages/EditEvent';
import SharcIdPage from './pages/SharcIdPage';
import FestivalList from './pages/FestivalList';
import FestivalDetail from './pages/FestivalDetail';
import AddFestival from './pages/AddFestival';
import EditFestival from './pages/EditFestival';
import PromoterList from './pages/PromoterList';
import PromoterDetail from './pages/PromoterDetail';
import AddPromoter from './pages/AddPromoter';
import EditPromoter from './pages/EditPromoter';
import './App.css';

function NavBar({ signOut, user }) {
    const location = useLocation();
    const isActive = (path) => location.pathname === path;
    return (
        <nav style={styles.nav}>
            <div style={styles.navBrand}>
                <Link to="/" style={styles.brandLink}>
                    <img src={sharcLogo} alt="SHARC" style={styles.navLogo} />
                </Link>
            </div>
            <div style={styles.navLinks}>
                <Link to="/artists" style={{...styles.navLink, ...(isActive('/artists') ? styles.navLinkActive : {})}}>Artists</Link>
                <Link to="/venues" style={{...styles.navLink, ...(isActive('/venues') ? styles.navLinkActive : {})}}>Venues</Link>
                <Link to="/events" style={{...styles.navLink, ...(isActive('/events') ? styles.navLinkActive : {})}}>Events</Link>
                <Link to="/festivals" style={{...styles.navLink, ...(isActive('/festivals') ? styles.navLinkActive : {})}}>Festivals</Link>
                <Link to="/promoters" style={{...styles.navLink, ...(isActive('/promoters') ? styles.navLinkActive : {})}}>Promoters</Link>
                <div style={styles.navDivider} />
                <Link to="/add-artist" style={styles.addButton}>+ Artist</Link>
                <Link to="/add-venue" style={styles.addButton}>+ Venue</Link>
                <Link to="/add-event" style={styles.addButton}>+ Event</Link>
                <Link to="/add-festival" style={styles.addButton}>+ Festival</Link>
                <Link to="/add-promoter" style={styles.addButton}>+ Promoter</Link>
                <button onClick={signOut} style={styles.signOutButton}>Sign Out</button>
            </div>
        </nav>
    );
}

function Home() {
    useEffect(() => {
        document.title = 'SHARC - Shows Archive';
    }, []);
    return (
        <div style={styles.home}>
            <img src={sharcLogo} alt="SHARC" style={styles.homeLogo} />
            <p style={styles.homeSubtitle}>A comprehensive catalog of live performances, artists, and venues.</p>
            <div style={styles.homeCards}>
                <Link to="/artists" style={styles.homeCard}>
                    <div style={styles.homeCardIcon}>🎸</div>
                    <div style={styles.homeCardLabel}>Artists</div>
                </Link>
                <Link to="/venues" style={styles.homeCard}>
                    <div style={styles.homeCardIcon}>🏛️</div>
                    <div style={styles.homeCardLabel}>Venues</div>
                </Link>
                <Link to="/events" style={styles.homeCard}>
                    <div style={styles.homeCardIcon}>📅</div>
                    <div style={styles.homeCardLabel}>Events</div>
                </Link>
                <Link to="/add-event" style={styles.homeCard}>
                    <div style={styles.homeCardIcon}>🎟️</div>
                    <div style={styles.homeCardLabel}>Add Event</div>
                </Link>
            </div>
        </div>
    );
}

function App() {
    return (
        <Authenticator hideSignUp={true}>
            {({ signOut, user }) => (
                <Router>
                    <div style={styles.app}>
                        <NavBar signOut={signOut} user={user} />
                        <main style={styles.main}>
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/artists" element={<ArtistList />} />
                                <Route path="/artists/:slug" element={<ArtistDetail />} />
                                <Route path="/venues" element={<VenueList />} />
                                <Route path="/venues/:slug" element={<VenueDetail />} />
                                <Route path="/events" element={<EventList />} />
                                <Route path="/events/:slug" element={<EventDetail />} />
                                <Route path="/artists/:slug/edit" element={<EditArtist />} />
                                <Route path="/venues/:slug/edit" element={<EditVenue />} />
                                <Route path="/events/:slug/edit" element={<EditEvent />} />
                                <Route path="/add-artist" element={<AddArtist />} />
                                <Route path="/add-venue" element={<AddVenue />} />
                                <Route path="/add-event" element={<AddEvent />} />
                                <Route path="/festivals" element={<FestivalList />} />
                                <Route path="/festivals/:slug" element={<FestivalDetail />} />
                                <Route path="/festivals/:slug/edit" element={<EditFestival />} />
                                <Route path="/add-festival" element={<AddFestival />} />
                                <Route path="/promoters" element={<PromoterList />} />
                                <Route path="/promoters/:slug" element={<PromoterDetail />} />
                                <Route path="/promoters/:slug/edit" element={<EditPromoter />} />
                                <Route path="/add-promoter" element={<AddPromoter />} />
                                <Route path="/:sharcId" element={<SharcIdPage />} />
                            </Routes>
                        </main>
                    </div>
                </Router>
            )}
        </Authenticator>
    );
}
const styles = {
    app: {
        minHeight: '100vh',
        backgroundColor: '#121212',
    },
    nav: {
        backgroundColor: '#1e1e1e',
        borderBottom: '1px solid #333',
        padding: '0 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '60px',
        position: 'sticky',
        top: 0,
        zIndex: 100,
    },
    navBrand: {
        fontSize: '20px',
        fontWeight: 'bold',
    },
    navLogo: {
        height: '28px',
        width: 'auto',
        display: 'block',
    },
    brandLink: {
        color: '#bb86fc',
        textDecoration: 'none',
        display: 'flex',
        alignItems: 'center',
    },
    navLinks: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    navLink: {
        color: '#aaa',
        textDecoration: 'none',
        padding: '6px 12px',
        borderRadius: '4px',
        fontSize: '14px',
    },
    navLinkActive: {
        color: '#bb86fc',
        backgroundColor: '#2c2c2c',
    },
    navDivider: {
        width: '1px',
        height: '24px',
        backgroundColor: '#444',
        margin: '0 8px',
    },
    addButton: {
        backgroundColor: '#bb86fc',
        color: '#121212',
        textDecoration: 'none',
        padding: '6px 12px',
        borderRadius: '4px',
        fontSize: '13px',
        fontWeight: 'bold',
    },
    main: {
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '32px 24px',
    },
    home: {
        textAlign: 'center',
        paddingTop: '80px',
    },
    homeLogo: {
        height: '80px',
        width: 'auto',
        marginBottom: '24px',
        display: 'block',
        margin: '0 auto 24px auto',
    },
    homeSubtitle: {
        fontSize: '18px',
        color: '#aaa',
        marginBottom: '64px',
    },
    homeCards: {
        display: 'flex',
        justifyContent: 'center',
        gap: '24px',
    },
    homeCard: {
        backgroundColor: '#1e1e1e',
        border: '1px solid #333',
        borderRadius: '12px',
        padding: '40px',
        textDecoration: 'none',
        color: '#e0e0e0',
        width: '160px',
    },
    homeCardIcon: {
        fontSize: '40px',
        marginBottom: '12px',
    },
    signOutButton: {
    backgroundColor: 'transparent',
    color: '#aaa',
    border: '1px solid #444',
    borderRadius: '4px',
    padding: '6px 12px',
    fontSize: '13px',
    cursor: 'pointer',
    marginLeft: '8px',
},
    homeCardLabel: {
        fontSize: '16px',
        fontWeight: 'bold',
    },
};
export default App;